'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-footer',
    cnItems = "".concat(CLASSNAME, "__items"),
    cnItem = "".concat(CLASSNAME, "__item");
/**
 * 
 */

var Footer = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Footer, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Footer);

  function Footer() {
    _rollupPluginBabelHelpers.classCallCheck(this, Footer);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(Footer, [{
    key: "render",
    value: function render() {
      var items = this.props.items;
      return /*#__PURE__*/React__default.createElement("footer", {
        className: classNames(CLASSNAME)
      }, /*#__PURE__*/React__default.createElement("ul", {
        className: cnItems
      }, items.map(function (item, index) {
        return /*#__PURE__*/React__default.createElement("li", {
          key: index
        }, /*#__PURE__*/React__default.createElement(Link, {
          link: item.link,
          className: cnItem
        }, item.title));
      })));
    }
  }]);

  return Footer;
}(React__default.Component);
Footer.propTypes = {
  /** Array of items to be displayed */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string
  }))
};
Footer.defaultProps = {
  items: []
};

module.exports = Footer;
